// buat kode booking details report
import { IconClock, IconLocation, IconMoneybag } from "@tabler/icons-react";
import React from "react";
import { Alert, Badge, Table } from "react-bootstrap";
import { getContrastColor } from "utils/utils";

const BookingDetailsComponent = ({ booking }) => {
  // Fungsi utilitas
  const formatPrice = (price) => {
    return new Intl.NumberFormat("id-ID").format(price);
  };

  const transportType = booking.guest_transport;
  // Lookup table untuk label & warna transportasi
  const transportDetails = {
    PU: {
      label: "Pick Up & Drop",
      badgeColor: "success",
      alertColor: "success",
    },
    D: { label: "Drop Only", badgeColor: "primary", alertColor: "primary" },
    P: { label: "Pick Only", badgeColor: "warning", alertColor: "warning" },
    OT: { label: "Own Transport", badgeColor: "danger", alertColor: "danger" },
  };

  // Default jika tidak sesuai dengan opsi
  const transport = transportDetails[transportType] || {
    label: "Unknown",
    badgeColor: "secondary",
    alertColor: "dark",
  };

  return (
    <div className="card shadow-sm">
      <div className="card-body">
        <div className="col-md-12">
          <div className="mb-3">
            <h4 className="card-title mb-2">
              Booking Code: {booking.code}
              {/* <pre>{JSON.stringify(booking, null, 2)}</pre> */}
            </h4>

            <Table
              bordered
              className="mb-2"
              size="sm"
              style={{ fontSize: "1rem" }}
            >
              <tbody>
                <tr>
                  <td className="text-muted fw-bold">Tanggal</td>
                  <td>{booking.reservation_date || "-"}</td>
                </tr>
                <tr>
                  <td className="text-muted fw-bold">Sesi</td>
                  <td>
                    {booking.trip?.name || "-"} |{" "}
                    {booking.trip?.start_time || "??:??"} -{" "}
                    {booking.trip?.end_time || "??:??"}
                  </td>
                </tr>
                <tr>
                  <td className="text-muted fw-bold">Track</td>
                  <td>
                    {booking.track === "A" ? (
                      <span className="badge">
                        {booking.track} <br />
                        <small>PREMIUM</small>
                      </span>
                    ) : (
                      <span className="badge bg-red text-white">
                        {booking.track} <br />
                        <small>REGULAR</small>
                      </span>
                    )}
                  </td>
                </tr>
                {/* ACTIVITY */}
                <tr>
                  <td className="text-muted fw-bold">Activity</td>
                  <td>
                    {booking.activities?.length > 0 ? (
                      booking.activities.map((activity) => (
                        <div key={activity.id} className="mb-1">
                          <span className="">
                            {/* {activity.activity} : {activity.qty} :  */}(
                            {activity.qty}x) : {activity.activity} : Rp.
                            {formatPrice(activity.price)}
                          </span>
                        </div>
                      ))
                    ) : (
                      <span className="text-muted">No Activity</span>
                    )}
                  </td>
                </tr>
                <tr>
                  <td className="text-muted fw-bold">Customer</td>
                  <td>{booking.customer?.name || "-"}</td>
                </tr>
                <tr>
                  <td className="text-muted fw-bold">Hotel</td>
                  <td>
                    {booking.customer?.nationality ||
                      booking.guest_nationality ||
                      "-"}
                  </td>
                </tr>
                <tr>
                  <td className="text-muted fw-bold">Phone</td>
                  <td>
                    {booking.customer?.phone || booking.guest_phone || "-"}
                  </td>
                </tr>
                <tr>
                  <td className="text-muted fw-bold">Email</td>
                  <td>
                    {booking.customer?.email || booking.guest_email || "-"}
                  </td>
                </tr>

                <tr>
                  <td className="text-muted fw-bold">Transport</td>
                  <td>
                    <Badge
                      bg={transport.badgeColor}
                      className="text-uppercase text-white"
                    >
                      {transport.label}
                    </Badge>
                  </td>
                </tr>
                <tr>
                  <td className="text-muted fw-bold">PAX</td>
                  <td>{booking.guest_pax || 0}</td>
                </tr>
                {/* Guest Mark */}
                <tr>
                  <td className="text-muted fw-bold">Guest Mark</td>
                  <td>{booking.guest_mark || "-"}</td>
                </tr>

                <tr>
                  <td className="text-muted fw-bold">Agent</td>
                  <td>{booking.agent?.name || "-"}</td>
                </tr>
                {booking.labels?.length > 0 && (
                  <tr>
                    <td className="text-muted fw-bold">Label</td>
                    <td className="d-flex flex-wrap gap-2">
                      {booking.labels.map((label) => (
                        <span
                          key={label.id}
                          className="badge text-uppercase"
                          title="Status Booking"
                          style={{
                            backgroundColor: label.color || "#ccc", // Warna dari API
                            color: getContrastColor(label.color), // Pastikan teks tetap terbaca
                          }}
                        >
                          {label.name}
                        </span>
                      ))}
                    </td>
                  </tr>
                )}
                <tr>
                  <td className="text-muted fw-bold">Driver</td>
                  <td>{booking.driver || "-"}</td>
                </tr>
                {/* payment methode */}
                <tr>
                  <td className="text-muted fw-bold">Payment Method</td>
                  <td>{booking.payment_method?.name || "-"}</td>
                </tr>
                {/* Payment Note */}
                <tr>
                  <td className="text-muted fw-bold">Payment Note</td>
                  <td>{booking.payment_note || "-"}</td>
                </tr>
                {/* 4 Last Number: */}
                <tr>
                  <td className="text-muted fw-bold">4 Last Number</td>
                  <td>{booking.last_number || "-"}</td>
                </tr>
                {/* Note */}
                <tr>
                  <td className="text-muted fw-bold">Note</td>
                  <td>{booking.note || "-"}</td>
                </tr>
              </tbody>
              {/* print json booking */}
            </Table>
            {/* <pre>{JSON.stringify(booking, null, 2)}</pre> */}
          </div>
          {/* {booking.labels?.length > 0 && (
                          <div className="text-muted mb-3">
                            <strong>Label:</strong>
                            <div className="d-flex flex-wrap gap-2 mt-1">
                              {booking.labels.map((label) => (
                                <span
                                  key={label.id}
                                  className="badge text-uppercase"
                                  title="Status Booking"
                                  style={{
                                    backgroundColor: label.color || "#ccc", // Warna dari API
                                    color: getContrastColor(label.color), // Pastikan teks tetap terbaca
                                  }}
                                >
                                  {label.name}
                                </span>
                              ))}
                            </div>
                          </div>
                        )} */}

          {/* Transportasi */}
          {/* <p className="text-muted">
                          <strong>Transportasi:</strong>{" "}
                          <Badge
                            bg={transport.badgeColor}
                            className="text-uppercase text-white"
                          >
                            {transport.label}
                          </Badge>
                        </p> */}
          {/* Detail Transportasi (jika PU, P, D) */}
          {["PU", "D", "P"].includes(transportType) && (
            <Alert variant={transport.alertColor} className="p-2">
              <p>
                <strong>
                  <IconClock /> Waktu:
                </strong>{" "}
                {booking.guest_pu_time || "-"}
              </p>
              <p>
                <strong>
                  <IconLocation /> Lokasi:
                </strong>{" "}
                {booking.guest_pu_location || "-"}
              </p>
              <p>
                <strong>
                  <IconMoneybag /> Harga:
                </strong>{" "}
                Rp. {formatPrice(booking.guest_pu_price || 0)}
              </p>
            </Alert>
          )}
        </div>
      </div>
    </div>
  );
};

export default BookingDetailsComponent;
